import { colors } from '@material-ui/core';

const white = '#FFFFFF';
const black = '#000000';

// Gym Fitness Tracker Design System - Pulse Pink/Orange 8px spacing
export default {
  black,
  white,
  primary: {
    contrastText: white,
    dark: '#E02640', // Primary-Hover
    main: '#FF2D47', // Primary
    light: '#FF6B78'
  },
  secondary: {
    contrastText: white,
    dark: '#A8145F', // Secondary darker
    main: '#D01A7F', // Secondary
    light: '#E84FA8'
  },
  accent: {
    contrastText: black,
    dark: '#E67500',
    main: '#FF8400', // Accent
    light: '#FFA640'
  },
  success: {
    contrastText: white,
    dark: '#0E8A3E',
    main: '#16A34A', // Success
    light: '#4ADE80'
  },
  warning: {
    contrastText: black,
    dark: '#D97706',
    main: '#F97316', // Warning
    light: '#FFA726'
  },
  info: {
    contrastText: white,
    dark: '#0891B2',
    main: '#0EA5E9', // Info
    light: '#38BDF8'
  },
  error: {
    contrastText: white,
    dark: '#B91C1C',
    main: '#DC2626', // Error
    light: '#F87171'
  },
  text: {
    primary: '#1C1C1E', // Text Primary
    secondary: '#3C3C43', // Text Secondary
    disabled: '#8E8E93', // Text Caption
    hint: '#8E8E93'
  },
  background: {
    default: '#F2F2F7', // Background
    paper: white,
    surface: '#FFFFFF', // Surface/Card
    border: '#E5E5EA' // Border
  },
  divider: '#E5E5EA',
  gradient: {
    primary: 'linear-gradient(135deg, #FF2D47 0%, #FF217C 50%, #FF6200 100%)',
    hero: 'linear-gradient(135deg, #FF217F 0%, #FF217C 25%, #FF6165 75%, #FF6068 100%)',
    workout: 'linear-gradient(135deg, #1250E6 0%, #FF8600 100%)'
  }
};
